const getSavedOnDiscountInPercent = (price, nextPrice) => {
  const percents = 100 - (price * 100) / nextPrice;
  return percents % 1 > 0 ? percents.toFixed(2) : percents;
};

export default getSavedOnDiscountInPercent;
